import React from 'react';
import { AuthLayout } from '../../../components/layout/Layouts'; 
import Payroll from '../../../components/Dashboard/Payroll';

const PayrollPage = () => {
  return (
    <AuthLayout>
      <Payroll />
    </AuthLayout>
  );
};

export default PayrollPage;
